import DOMPurify from 'dompurify';

interface SanitizeHtmlOptions {
  /** Balises autorisées. Non fourni => set par défaut de DOMPurify (large). */
  allowedTags?: string[];
  allowedAttr?: string[];
}

/**
 * Point d'entrée unique pour l'assainissement HTML côté front. Chaque appelant garde
 * sa propre politique (allowlist, résolution i18n en amont, etc.) via les options ;
 * seul l'appel DOMPurify lui-même est mutualisé ici.
 */
export function sanitizeHtml(html: string, options: SanitizeHtmlOptions = {}): string {
  return DOMPurify.sanitize(html, {
    ...(options.allowedTags ? { ALLOWED_TAGS: options.allowedTags } : {}),
    ALLOWED_ATTR: options.allowedAttr ?? ['href', 'target', 'rel']
  });
}
